export default __webpack_public_path__ + "static/media/mern_tip_calc.4a1b8f7e.webp";